import translations from '../i18n/translation'
import {addLocaleData, IntlProvider} from 'react-intl';
import LocaleSettings from "./LocaleSettings";

addLocaleData(LocaleSettings.getDefaultIntlLocale());
const intlProvider = new IntlProvider({
    locale: LocaleSettings.getDefaultLocaleString(),
    messages: translations.messages
}, {});

const {intl} = intlProvider.getChildContext();

export const plainJSTranslator = intl;




// WEBPACK FOOTER //
// ./web/src/common/PlainJSTranslator.js